import { Dimensions, FlatList, Modal, PixelRatio, StyleSheet, Text, View } from "react-native";
import React, { useEffect, useState } from "react";
import Colours from "../../utils/Colours";
import { TouchableOpacity } from "react-native";
import useAuth from "../../hooks/useAuth";
import ErrorAlertComp from "../../alertComp/ErrorAlertComp";
import { Image } from "expo-image";

const { width, height } = Dimensions.get("window");
const dpr = Math.round(PixelRatio.get() || 1);
// Base width (e.g., iPhone 11 - 375px)
const BASE_WIDTH = 375;
const BASE_HEIGHT = 812;
const VAL_NAME = "dxfdmlk0f";
const MAX_RETRIEZ = 20;

// Function to adjust font size
const dynamicFontSize = (size) => {
  const scaleFactor = Math.min(width / BASE_WIDTH, height / BASE_HEIGHT);
  const newSize = size * scaleFactor;

  return Math.round(PixelRatio.roundToNearestPixel(newSize));
};

// Function for dynamic spacing (padding, margin, gap)
const dynamicSpacing = (size) => (width / BASE_WIDTH) * size;

// Function for dynamic sizing (width, height, borderRadius)
const dynamicSize = (size) => (width / BASE_WIDTH) * size;

const dynamicThumbnailWidth = Math.round((width / BASE_WIDTH) * 60);
const dynamicThumbnailHeight = Math.round((width / BASE_WIDTH) * 60);
const fullScreenImageWidth = Math.round(width * 0.9);
const fullScreenImageHeight = Math.round(height * 0.7);

const PublicProfileBody = ({ userData }) => {
  const [showCreateCelebratoryPullModal, setShowCreateCelebratoryPullModal] = useState(false);
  const [isErrorCompVisible, setIsErrorCompVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isButtonClicked, setIsButtonClicked] = useState(false);
  const [showViewImages, setShowViewImages] = useState(false);
  const [selectedImg, setSelectedImg] = useState(null);

  const [retryCount, setRetryCount] = useState(0);
  const [imageKey, setImageKey] = useState(0);

  const { username, activitySettings } = useAuth();

  const isLoggedInUser = userData?.username === username;

  useEffect(() => {
    //console.log("userDataBVB", userData);
  }, []);

  const celebrateUser = () => {
    if (!activitySettings.canCelebrateUser) {
      setErrorMessage(
        "Creating celebratory or birthday pulls is not available at the moment, please try again later",
      );
      setIsErrorCompVisible(true);
      return;
    }
    setIsButtonClicked(!isButtonClicked);
    setShowCreateCelebratoryPullModal(true);
  };
  const handleImagePress = (selectedImg) => {
    ////console.log('selectedIMG', selectedImg)
    setSelectedImg(selectedImg); // Store the selected image URL
    setShowViewImages(true);
  };

  const getOptimizedCloudinaryUrl = (originalUrl, targetWidth, targetHeight) => {
    if (!originalUrl || !originalUrl.includes(VAL_NAME)) {
      return originalUrl;
    }

    // 1. Define the transformations
    const transformations = `w_${targetWidth},h_${targetHeight},c_fill,f_auto,q_90,dpr_${dpr}`;

    //const transformations = `w_${targetWidth},f_auto,q_90,dpr_auto`;

    const regex = /upload\/v\d+\//;

    return originalUrl.replace(regex, `upload/${transformations}/`);
  };

  const handleImageError = () => {
    if (retryCount < MAX_RETRIEZ) {
      // Increment the retry counter
      setRetryCount((prevCount) => prevCount + 1);

      // Force component re-render by changing the key
      setImageKey((prevKey) => prevKey + 1);

      ////console.log(`Image failed to load. Retrying... Attempt ${retryCount + 1}`);
    } else {
      // Log final failure or set a state to show a permanent fallback icon
      ////console.log('Image failed to load after maximum retries.');
    }
  };

  const newUserFullImage = getOptimizedCloudinaryUrl(
    selectedImg,
    fullScreenImageWidth,
    fullScreenImageHeight,
  );

  ////console.log('newUserFullImage', newUserFullImage)

  return (
    <View style={styles.profileBodyCont}>
      <View style={styles.pullCRED}>
        <View style={styles.pullCREDRow}>
          {/* Encircled Question Mark */}
          {/* <View style={styles.questionMarkCircle}> */}
          {/* <Text style={styles.questionMarkText}>?</Text> */}
          {/* </View> */}
          <Text
            style={{
              fontSize: dynamicFontSize(17),
              fontFamily: "Sen-Bold",
              color: Colours.DARKGRAY,
            }}
          >
            {/* PullCRED */}
            CRED
            {userData?.pullCred !== 0 && (
              <Text
                style={{
                  color: Colours.PRIMARY,
                  fontSize: dynamicFontSize(20),
                  fontFamily: "Sen-Bold",
                }}
              >
                {" "}
                {userData?.pullCred}
              </Text>
            )}
          </Text>
        </View>
      </View>
      {userData?.images?.length > 0 && (
        <View style={styles.pictureGallaryStyles}>
          <FlatList
            data={userData?.images}
            horizontal
            keyExtractor={(item, index) => index.toString()}
            renderItem={({ item }) => {
              const userImageThumbnailUrl = item?.url;

              const newUserImageThumbnailUrl = getOptimizedCloudinaryUrl(
                userImageThumbnailUrl,
                dynamicThumbnailWidth,
                dynamicThumbnailHeight,
              );

              return (
                <TouchableOpacity onPress={() => handleImagePress(item?.url)}>
                  <Image
                    source={{ uri: newUserImageThumbnailUrl }}
                    key={imageKey}
                    style={[styles.picImageContr, { backgroundColor: "#d6d4d4ff" }]}
                    contentFit="cover"
                    cachePolicy="disk"
                    onError={handleImageError}
                  />
                </TouchableOpacity>
              );
            }}
          />
        </View>
      )}

      {/* {!isLoggedInUser && (
        <TouchableOpacity
          style={[
            styles.buttonGray,
            { backgroundColor: isButtonClicked ? Colours.PRIMARY : Colours.LIGHTGRAY },
          ]}
          onPress={celebrateUser}
        >
          <Text
            style={{
              color: isButtonClicked ? "white" : Colours.DARKGRAY,
              fontSize: 17,
              fontFamily: "Sen-Bold",
            }}
          >
            Celebrate {userData?.username}
          </Text>
        </TouchableOpacity>
      )} */}

      {userData?.bio && userData.bio.trim().length > 0 && (
        <>
          <Text style={styles.aboutTxt}>ABOUT</Text>
          <View style={styles.pictureGallaryStyles}>
            <Text style={styles.bioTxt}>{userData?.bio}</Text>
          </View>
        </>
      )}
      {/* 
            {userData?.socialAccount && userData.socialAccount.trim().length > 0 && (
                <>
                    <Text style={styles.socialsTxt}>SOCIALS</Text>
                    <View style={styles.socialsContaner}>
                        <View style={styles.socials}>
                            <Text style={styles.socialAccountsTxt}>
                                {userData?.socialAccount}
                            </Text>
                        </View>
                    </View>
                </>)} */}

      {/**BRANDS: companies or businesses user associates with, works at or own: tagged with; worksAt, worksWith, or owns*/}
      {/* <Text style={styles.recentDoingsTxt}>RECENT DOINGZ</Text>
            <View style={styles.rescentDoingsContainer}>
                <View style={styles.socials}>
                    <Text style={styles.recentsTxt}>
                        Tables - Total Value
                    </Text>
                    <Text style={styles.recentsTxt2}>
                        - 500,000
                    </Text>
                </View>
                <View style={styles.recentscontents}>
                    <Text style={styles.recentsTxt2}>
                        The Boss James
                    </Text>
                    <Text style={styles.recentsTxt2}>
                        King Mark
                    </Text>
                </View>
            </View>
            <View style={styles.rescentDoingsContainer}>
                <View style={styles.socials}>
                    <Text style={styles.recentsTxt}>
                        Gifts & Supports - Total Value
                    </Text>
                    <Text style={styles.recentsTxt2}>
                        - 1,000,000
                    </Text>
                </View>
                
            </View> */}

      {/* Modal for Viewing Image */}
      <Modal animationType="fade" visible={showViewImages} transparent>
        <View style={styles.modalContainer}>
          <TouchableOpacity onPress={() => setShowViewImages(false)} style={styles.closeButton}>
            <Text style={styles.closeText}>Close</Text>
          </TouchableOpacity>

          {selectedImg && (
            <Image
              source={{ uri: newUserFullImage }}
              key={imageKey}
              style={[styles.fullScreenImage, { backgroundColor: "#d6d4d4ff" }]}
              contentFit="cover"
              cachePolicy="disk"
              onError={handleImageError}
            />
          )}
        </View>
      </Modal>

      <Modal visible={isErrorCompVisible} transparent={true} animationType="fade">
        <ErrorAlertComp message={errorMessage} onClose={() => setIsErrorCompVisible(false)} />
      </Modal>
    </View>
  );
};

const styles = StyleSheet.create({
  pictureGallaryStyles: {
    flexDirection: "row",
    marginBottom: dynamicSpacing(15),
    padding: dynamicSpacing(10),
    backgroundColor: "white",
    borderRadius: dynamicSize(15),
    gap: dynamicSpacing(10),
  },
  aboutTxt: {
    marginBottom: dynamicSpacing(5),
    color: Colours.PRIMARY,
    fontSize: dynamicFontSize(12),
    fontFamily: "Sen-Medium",
  },
  bioTxt: {
    color: Colours.DARKGRAY,
    fontSize: dynamicFontSize(13),
    fontFamily: "Sen-Regular",
    textAlign: "justify",
  },
  socialsTxt: {
    marginBottom: dynamicSpacing(5),
    color: Colours.PRIMARY,
    fontSize: dynamicFontSize(12),
    fontFamily: "Sen-Medium",
  },
  socialAccountsTxt: {
    color: Colours.PRIMARY,
    fontSize: dynamicFontSize(13),
    fontFamily: "Sen-Regular",
  },

  pullCREDRow: {
    flexDirection: "row",
    alignItems: "center",
  },
  questionMarkCircle: {
    width: dynamicSize(12),
    height: dynamicSize(12),
    borderRadius: dynamicSize(8),
    borderWidth: dynamicSize(1.5),
    borderColor: Colours.DARKGRAY,
    alignItems: "center",
    justifyContent: "center",
    marginRight: dynamicSpacing(6),
  },
  questionMarkText: {
    fontSize: dynamicFontSize(12),
    fontFamily: "Sen-Bold",
    color: Colours.DARKGRAY,
  },

  recentDoingsTxt: {
    marginBottom: dynamicSpacing(5),
    color: Colours.PRIMARY,
    fontSize: dynamicFontSize(12),
    fontFamily: "Sen-Medium",
  },
  recentsTxt: {
    color: Colours.PRIMARY,
    fontSize: dynamicFontSize(13),
    fontFamily: "Sen-Regular",
  },
  recentsTxt2: {
    color: Colours.DARKGRAY,
    fontSize: dynamicFontSize(13),
    // marginBottom: dynamicSpacing(10),
    fontFamily: "Sen-Regular",
  },
  socialsContaner: {
    marginBottom: dynamicSpacing(15),
    padding: dynamicSpacing(10),
    backgroundColor: "white",
    borderRadius: dynamicSize(15),
    gap: dynamicSpacing(10),
  },
  rescentDoingsContainer: {
    display: "flex",
    marginBottom: dynamicSpacing(15),
    padding: dynamicSpacing(10),
    backgroundColor: "white",
    borderRadius: dynamicSize(15),
    gap: dynamicSpacing(10),
  },
  recentscontents: {
    display: "flex",
    borderRadius: dynamicSize(10),
    padding: dynamicSpacing(10),
    backgroundColor: Colours.PRIMARY_LIGHTER,
  },
  socials: {
    flexDirection: "row",
    alignItems: "center",
    gap: dynamicSpacing(5),
  },
  picImageContr: {
    height: dynamicSize(60),
    width: dynamicSize(60),
    borderRadius: dynamicSize(15),
    marginRight: dynamicSpacing(10),
  },
  profileBodyCont: {
    padding: dynamicSpacing(15),
  },
  buttonGray: {
    borderRadius: dynamicSize(10),
    justifyContent: "center",
    alignItems: "center",
    height: dynamicSize(55),
    width: "100%",
    backgroundColor: Colours.DARKGRAY,
    marginBottom: dynamicSpacing(10),
  },
  pullCRED: {
    // borderRadius: dynamicSize(10),
    justifyContent: "center",
    alignItems: "center",
    height: dynamicSize(55),
    width: "100%",
    backgroundColor: Colours.LIGHTGRAY,
    marginBottom: dynamicSpacing(10),
  },
  modalContainer: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "rgba(0, 0, 0, 0.8)",
  },
  closeButton: {
    position: "absolute",
    top: dynamicSpacing(50),
    right: dynamicSpacing(20),
    padding: dynamicSpacing(10),
    backgroundColor: "rgba(255, 255, 255, 0.3)",
    borderRadius: dynamicSize(10),
  },
  closeText: {
    color: "#fff",
    fontSize: dynamicFontSize(18),
  },
  fullScreenImage: {
    width: "90%",
    height: "70%",
    resizeMode: "contain",
  },
});

export default PublicProfileBody;
